import { render, staticRenderFns } from "./gongxu_video.vue?vue&type=template&id=06ddac10&scoped=true"
import script from "./gongxu_video.vue?vue&type=script&lang=js"
export * from "./gongxu_video.vue?vue&type=script&lang=js"
import style0 from "./gongxu_video.vue?vue&type=style&index=0&id=06ddac10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ddac10",
  null
  
)

export default component.exports